import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSecurity = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "security",
	xmlns: "http://www.w3.org/2000/svg",
	width: 45.915,
	height: 57.092,
	viewBox: "0 0 45.915 57.092",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Path_68825",
		"data-name": "Path 68825",
		d: "M2991.992-402c0-3.223.024-6.446-.014-9.669a2.27,2.27,0,0,1,1.444-2.346q10.189-4.6,20.364-9.227a2.656,2.656,0,0,1,2.357.03q10.083,4.585,20.18,9.134a2.37,2.37,0,0,1,1.555,2.4c-.023,6.309.065,12.619-.034,18.926a19.7,19.7,0,0,1-8.182,16.06c-4.367,3.308-8.856,6.454-13.3,9.664a1.977,1.977,0,0,1-2.881,0c-4.575-3.314-9.21-6.552-13.7-9.983a18.434,18.434,0,0,1-7.569-13.578c-.29-3.78-.055-7.6-.055-11.4Zm22.893,31.254a3.974,3.974,0,0,0,.382-.215c4.131-2.993,8.323-5.907,12.373-9.005a15.5,15.5,0,0,0,6.344-12.662c.062-5.827.009-11.655.032-17.483a1.07,1.07,0,0,0-.745-1.149c-5.895-2.643-11.771-5.324-17.669-7.958a1.812,1.812,0,0,0-1.322-.009c-5.9,2.633-11.776,5.313-17.668,7.96a1.07,1.07,0,0,0-.771,1.13c.029,5.93-.032,11.862.043,17.791a14.982,14.982,0,0,0,5.809,11.981C3005.958-376.99,3010.478-373.94,3014.885-370.748Z",
		transform: "translate(-2991.979 423.505)",
		fill: "#fff"
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_68826",
		"data-name": "Path 68826",
		d: "M3060.878-349.486c0-1.292-.007-2.484,0-3.675a5.676,5.676,0,0,1,5.544-5.81,5.667,5.667,0,0,1,5.844,5.625c.048,1.228.007,2.46.007,3.861.578,0,1.075-.011,1.572,0,1.541.039,2.287.757,2.293,2.276q.023,5.4,0,10.8a1.912,1.912,0,0,1-2.168,2.142q-7.409.018-14.816,0a1.9,1.9,0,0,1-2.13-2.175c-.014-3.533-.007-7.065,0-10.6,0-1.732.692-2.426,2.42-2.449C3059.882-349.491,3060.321-349.486,3060.878-349.486Zm.049,11.4H3072.2v-7.482h-11.274Zm3.725-11.487h3.856c0-1.274.053-2.469-.016-3.658a1.86,1.86,0,0,0-1.985-1.9,1.865,1.865,0,0,0-1.846,1.938C3064.618-352,3064.653-350.812,3064.653-349.568Z",
		transform: "translate(-3043.632 372.254)",
		fill: "#fff"
	})]
});
export default SvgSecurity;
